module.exports = __webpack_public_path__ + "img/logo_qr.4c298d89.png";